// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__1QP0R","title":"AfterBackImages_title__G-Oht","images":"AfterBackImages_images__3P1UP"};